import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

import { toRefs } from 'vue';

interface Props {
  students?: Student[];
}

interface Student {
  id: number;
  display_name: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StudentInSeat',
  props: {
    students: {}
  },
  setup(__props: any) {

const props = __props;

const { students } = toRefs(props);

const sorted = (arr: { id: number; display_name: string }[]) => {
  if (arr.length > 1) {
    const sortedList = arr.sort((a, b) => {
      const stringA = a.display_name;
      const stringB = b.display_name;
      if (stringA && stringB) return stringA.localeCompare(stringB);
      else return 1;
    });

    return sortedList;
  } else return arr;
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sorted(_unref(students) as Student[]), (student) => {
    return (_openBlock(), _createElementBlock("div", {
      key: student.id,
      class: "student border-none border-bottom-1 align-content-center flex p-3 w-full"
    }, [
      _createVNode(_component_RouterLink, {
        to: `/user/${student.id}`,
        class: "font-semibold",
        textContent: _toDisplayString(student.display_name)
      }, null, 8, ["to", "textContent"])
    ]))
  }), 128))
}
}

})